import { invoke } from "@shared/easyfy.decorators";
import { globalEvent } from "@shared/easyfy.core";
import { addCss, removeCss} from '@shared/easyfy.utils';
import Splide from '@splidejs/splide';
import { GetProductOption } from "../services/productvariant.service";
  
namespace Easyfy.Web.Pages {
  @invoke
  class Product {

    constructor() {

    }

    onInit() {
        globalEvent({
          type: 'click',
          event: {
            event: 'change-image',
            callback: Product.changeImage
          }
        });

      globalEvent({
        type: 'change',
        event: {
          action: 'change-product-variant',
          callback: Product.changeProductVariant
        }
      });

      document.querySelectorAll('[data-container="product-images-slider"]').forEach(item => {
        item.classList.add("splide");
        console.log(item)
        const slider = new Splide(item as HTMLElement, {
          type: 'slide',
          perPage: 6,
          dragMinThreshold: 20,
          gap: 25,
          arrows: false,
          snap: false,
          pagination: false,
          breakpoints: {
            1000: {
              perPage: 3,
            }

          }
        }).mount();
      });
    }

    static changeImage(e) {
      e.preventDefault();

      const element: HTMLElement = e.srcElement as HTMLElement;
      const imageContainer: HTMLElement = document.querySelector('[data-container="product-images"]') as HTMLElement;
      const img = imageContainer.querySelector('img') as HTMLElement;
      console.log(img)
      console.log(element)
      let imageSrc = element.getAttribute('href');

      if (!imageSrc) {
        imageSrc = element.parentElement.getAttribute('href');
      }
      console.log(imageSrc)
      //img.removeAttribute('src');;
      //img.removeAttribute('srcset');
      img.setAttribute('src', imageSrc);;
      img.setAttribute('srcset', imageSrc);
      img.parentElement.querySelectorAll('source').forEach(source => {
        source.setAttribute("srcset", imageSrc)
      })
      console.log(img.parentElement)
      removeCss(document.querySelectorAll('[data-event="change-image"]'), 'active');
      addCss(element, 'active');

      return false;
    }

    static changeProductVariant(e) {
      const element = e.target as HTMLSelectElement;
      const selectedValue = element.value;
      const productImagesContainer = document.querySelector('[data-container="product-images"]');
      const productActionsContainer = document.querySelector('[data-container="product-actions"]');
      const productInfoContainer = document.querySelector('[data-container="product-bottom-info"]');

      GetProductOption(selectedValue)
        .then((response) => {
          if (response?.data?.success) {
            if (response?.data?.partialHtmlProdImages != null) {
              productImagesContainer.innerHTML = response.data.partialHtmlProdImages;
            }

            if (response?.data?.partialHtmlProdActions != null) {
              productActionsContainer.innerHTML = response.data.partialHtmlProdActions;
            }

            if (response?.data?.partialHtmlProductInfo != null) {
              productInfoContainer.innerHTML = response.data.partialHtmlProductInfo;
            }
            
          }
         
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
}

export default Easyfy.Web.Pages;